import { Typography, TypographyProps } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { ProjectInBuyerViewSelector } from '../store/selectors/projectInBuyerViewSelector'
import { ProjectProcessFlowSelector } from '../store/selectors/ProjectProcessFlowSelector'

export const ProjectProcessFlow = (props: TypographyProps) => {
  const flowType = useAppSelector(ProjectProcessFlowSelector)
  const { t } = useTranslation()
  const isBuyingPartyView = useAppSelector(ProjectInBuyerViewSelector)

  if (!flowType || isBuyingPartyView) {
    return null
  }

  return (
    <Typography variant="caption" color="textSecondary" {...props}>
      {t('project:process-flow', 'process flow: {{processFlow}}', {
        processFlow: flowType,
      })}
    </Typography>
  )
}
